/* 用户相关 */
/* 用户相关所有接口前面多加/用于判断请求不同的接口地址，实际请求时再过滤掉 */
import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
// const baseURL = process.env.VUE_APP_BASE_URL

// 登录
export function Login(data) {
  return request({
    url: '/login',
    method: 'POST',
    data
  })
}
// 验证码
export function captchaImage() {
  return request({
    url: '/captchaImage',
    method: 'GET'
  })
}
// 校验邮箱的唯一性
export function emailUnique(param) {
  const url = handlerGetUrlParams('/email', param)
  return request({
    url,
    method: 'GET'
  })
}
// 注册
export function Register(data) {
  return request({
    url: '/register',
    method: 'POST',
    data
  })
}
// 忘记密码
export function forgetPwd(data) {
  return request({
    url: '/forgetPwd',
    method: 'POST',
    data
  })
}

// token校验
export function checkToken(token) {
  return request({
    url: '/check/token',
    method: 'POST',
    data: {
      token
    }
  })
}
// 账号是否已经登录
export function checkTokenIsLogin(data) {
  const url = handlerGetUrlParams('/ourchem-middle/oauth/check/user', data)
  return request({
    url,
    method: 'GET'
  })
}
